<template>

  <wgu-app-tpl>
    <!-- insert your app slots here  -->

    <div slot="wgu-tb-after-title" class="">
      <v-img
        contain
        height="50"
        width="50"
        src="static/data/wnstr-reise/deutsche-weinstrasse.svg"
      />
    </div>

    <wsr-infowin
      slot="wgu-tb-after-auto-buttons"
      :color="baseColor"
    >
    </wsr-infowin>

    <wsr-sidebar
      slot="wgu-after-header"
      :value="showRightSidebar"
      @toggle="showRightSidebar=$event"
      ref="rightSidebar"
      :color="baseColor"
    ></wsr-sidebar>

  </wgu-app-tpl>

</template>

<script>
  import Vue from 'vue';
  import WguAppTemplate from './WguAppTemplate.vue';
  import WsrSidebar from './components/Sidebar';
  import WsrInfoWin from './components/InfoWin';

  export default {
    name: 'wgu-app',
    components: {
      'wgu-app-tpl': WguAppTemplate,
      'wsr-sidebar': WsrSidebar,
      'wsr-infowin': WsrInfoWin
    },
    data () {
      return {
        showRightSidebar: true,
        baseColor: Vue.prototype.$appConfig.baseColor
      }
    },
    mounted () {
      console.log();
    },
    methods: {
    }
  }
</script>

<style>

  .v-toolbar__title {
    color: rgba(0, 0, 0, 0.87);
  }
  .theme--light.v-footer {
    color: rgba(0, 0, 0, 0.6) !important;
  }

</style>



// WEBPACK FOOTER //
// app/WguApp.vue